import { createAction } from '@reduxjs/toolkit';
import { IFetchEmailLogsPayload, IEmailLogsResponse, IEmailLogStats, types } from './types';
import { IErrorType } from '../../constants/types';

export const fetchEmailLogs = createAction<IFetchEmailLogsPayload>(types.FETCH_EMAIL_LOGS);
export const fetchEmailLogsSuccess = createAction<IEmailLogsResponse>(types.FETCH_EMAIL_LOGS_SUCCESS);
export const fetchEmailLogsFail = createAction<IErrorType>(types.FETCH_EMAIL_LOGS_FAIL);

export const fetchEmailLogStats = createAction<{ startDate?: string; endDate?: string }>(types.FETCH_EMAIL_LOG_STATS);
export const fetchEmailLogStatsSuccess = createAction<IEmailLogStats>(types.FETCH_EMAIL_LOG_STATS_SUCCESS);
export const fetchEmailLogStatsFail = createAction<IErrorType>(types.FETCH_EMAIL_LOG_STATS_FAIL);
